import { i18n } from '@/plugins/i18n';

export const TRANSACTION_TYPES = {
    chargeThroughTransferFromCompanyOtherBankAccount: 1000,
    chargeThroughBankReceipt: 1001,
    chargeThroughSamanDepositWithId: 1002,
    chargeThroughSaderatDepositWithId: 1003,
    chargeThroughShaparakSettlement: 1004,
    chargeThroughPspDirectSettlement: 1005,
    chargeThroughAyandeDirectDebit: 1006,
    chargeThroughSaderatDirectDebit: 1007,
    chargeThroughWalletReversalSettlement: 1008,
    chargeThroughBankLoan: 1009,
    chargeThroughCompanyLoanWage: 1010,
    chargeThroughSellingProperties: 1011,
    chargeThroughSellingServices: 1012,
    chargeThroughResolvingConflictsFromBank: 1013,
    chargeThroughReturnOfLend: 1014,
    chargeThroughTakingLend: 1015,
    chargeThroughBankAccountProfit: 1016,
    chargeThroughIvrSettlement: 1017,
    chargeThroughSamanDirectDebit: 1018,
    chargeOfUnverifiedOrSuspiciousTransaction: 1998,
    chargeOfUnknownOrUnclassifiedTransaction: 1999,
    withdrawForWalletSettlement: 2000,
    withdrawForTransferToCompanyOtherBankAccount: 2001,
    withdrawForBankWageOfWalletSettlement: 2002,
    withdrawForBankWageOfTransferToCompanyOtherBankAccount: 2003,
    withdrawForPayingDailyCompanyWage: 2004,
    withdrawForBankServices: 2005,
    withdrawForBankLoanWage: 2006,
    withdrawForCompanyLoan: 2007,
    withdrawForBuyingProperties: 2008,
    withdrawForBuyingServices: 2009,
    withdrawForResolvingConflictsFromBank: 2010,
    withdrawForGivingLend: 2011,
    withdrawForReturnOfLend: 2012,
    withdrawForPayingEmployeesSalariesAndBenefits: 2013,
    withdrawOfUnverifiedOrSuspiciousTransaction: 2998,
    withdrawOfUnknownOrUnclassifiedTransaction: 2999,
    createdByAdmin: 3000,
};


export const TRANSACTION_TYPES_STR = {
    chargeThroughTransferFromCompanyOtherBankAccount: i18n.t('accounting.transaction_types.1000'),
    chargeThroughBankReceipt: i18n.t('accounting.transaction_types.1001'),
    chargeThroughSamanDepositWithId: i18n.t('accounting.transaction_types.1002'),
    chargeThroughSaderatDepositWithId: i18n.t('accounting.transaction_types.1003'),
    chargeThroughShaparakSettlement: i18n.t('accounting.transaction_types.1004'),
    chargeThroughPspDirectSettlement: i18n.t('accounting.transaction_types.1005'),
    chargeThroughAyandeDirectDebit: i18n.t('accounting.transaction_types.1006'),
    chargeThroughSaderatDirectDebit: i18n.t('accounting.transaction_types.1007'),
    chargeThroughWalletReversalSettlement: i18n.t('accounting.transaction_types.1008'),
    chargeThroughBankLoan: i18n.t('accounting.transaction_types.1009'),
    chargeThroughCompanyLoanWage: i18n.t('accounting.transaction_types.1010'),
    chargeThroughSellingProperties: i18n.t('accounting.transaction_types.1011'),
    chargeThroughSellingServices: i18n.t('accounting.transaction_types.1012'),
    chargeThroughResolvingConflictsFromBank: i18n.t('accounting.transaction_types.1013'),
    chargeThroughReturnOfLend: i18n.t('accounting.transaction_types.1014'),
    chargeThroughTakingLend: i18n.t('accounting.transaction_types.1015'),
    chargeThroughBankAccountProfit: i18n.t('accounting.transaction_types.1016'),
    chargeThroughIvrSettlement: i18n.t('accounting.transaction_types.1017'),
    chargeThroughSamanDirectDebit: i18n.t('accounting.transaction_types.1018'),
    chargeOfUnverifiedOrSuspiciousTransaction: i18n.t('accounting.transaction_types.1998'),
    chargeOfUnknownOrUnclassifiedTransaction: i18n.t('accounting.transaction_types.1999'),
    withdrawForWalletSettlement: i18n.t('accounting.transaction_types.2000'),
    withdrawForTransferToCompanyOtherBankAccount: i18n.t('accounting.transaction_types.2001'),
    withdrawForBankWageOfWalletSettlement: i18n.t('accounting.transaction_types.2002'),
    withdrawForBankWageOfTransferToCompanyOtherBankAccount: i18n.t('accounting.transaction_types.2003'),
    withdrawForPayingDailyCompanyWage: i18n.t('accounting.transaction_types.2004'),
    withdrawForBankServices: i18n.t('accounting.transaction_types.2005'),
    withdrawForBankLoanWage: i18n.t('accounting.transaction_types.2006'),
    withdrawForCompanyLoan: i18n.t('accounting.transaction_types.2007'),
    withdrawForBuyingProperties: i18n.t('accounting.transaction_types.2008'),
    withdrawForBuyingServices: i18n.t('accounting.transaction_types.2009'),
    withdrawForResolvingConflictsFromBank: i18n.t('accounting.transaction_types.2010'),
    withdrawForGivingLend: i18n.t('accounting.transaction_types.2011'),
    withdrawForReturnOfLend: i18n.t('accounting.transaction_types.2012'),
    withdrawForPayingEmployeesSalariesAndBenefits: i18n.t('accounting.transaction_types.2013'),
    withdrawOfUnverifiedOrSuspiciousTransaction: i18n.t('accounting.transaction_types.2998'),
    withdrawOfUnknownOrUnclassifiedTransaction: i18n.t('accounting.transaction_types.2999'),
    createdByAdmin: i18n.t('accounting.transaction_types.3000'),

    get(transaction_type) {
        let transaction_type_str = null;

        Object.keys(TRANSACTION_TYPES).forEach(function (item) {
            if (TRANSACTION_TYPES[item] === transaction_type) {
                transaction_type_str = TRANSACTION_TYPES_STR[item];
            }
        });

        return transaction_type_str || i18n.t('accounting.transaction_types.unknown');
    }
};

export const TRANSACTION_TYPES_ACCOUNTING = {
    chargeThroughTransferFromCompanyOtherBankAccount: i18n.t('accounting.transaction_types.1000'),
    chargeThroughBankReceipt: i18n.t('accounting.transaction_types.1001'),
    chargeThroughSamanDepositWithId: i18n.t('accounting.transaction_types.1002'),
    chargeThroughSaderatDepositWithId: i18n.t('accounting.transaction_types.1003'),
    chargeThroughShaparakSettlement: i18n.t('accounting.transaction_types.1004'),
    chargeThroughPspDirectSettlement: i18n.t('accounting.transaction_types.1005'),
    chargeThroughAyandeDirectDebit: i18n.t('accounting.transaction_types.1006'),
    chargeThroughSaderatDirectDebit: i18n.t('accounting.transaction_types.1007'),
    chargeThroughWalletReversalSettlement: i18n.t('accounting.transaction_types.1008'),
    chargeThroughBankLoan: i18n.t('accounting.transaction_types.1009'),
    chargeThroughCompanyLoanWage: i18n.t('accounting.transaction_types.1010'),
    chargeThroughSellingProperties: i18n.t('accounting.transaction_types.1011'),
    chargeThroughSellingServices: i18n.t('accounting.transaction_types.1012'),
    chargeThroughResolvingConflictsFromBank: i18n.t('accounting.transaction_types.1013'),
    chargeThroughReturnOfLend: i18n.t('accounting.transaction_types.1014'),
    chargeThroughTakingLend: i18n.t('accounting.transaction_types.1015'),
    chargeThroughBankAccountProfit: i18n.t('accounting.transaction_types.1016'),
    chargeThroughIvrSettlement: i18n.t('accounting.transaction_types.1017'),
    chargeThroughSamanDirectDebit: i18n.t('accounting.transaction_types.1018'),
    chargeOfUnverifiedOrSuspiciousTransaction: i18n.t('accounting.transaction_types.1998'),
    chargeOfUnknownOrUnclassifiedTransaction: i18n.t('accounting.transaction_types.1999'),
    withdrawForWalletSettlement: i18n.t('accounting.transaction_types.2000'),
    withdrawForTransferToCompanyOtherBankAccount: i18n.t('accounting.transaction_types.2001'),
    withdrawForBankWageOfWalletSettlement: i18n.t('accounting.transaction_types.2002'),
    withdrawForBankWageOfTransferToCompanyOtherBankAccount: i18n.t('accounting.transaction_types.2003'),
    withdrawForPayingDailyCompanyWage: i18n.t('accounting.transaction_types.2004'),
    withdrawForBankServices: i18n.t('accounting.transaction_types.2005'),
    withdrawForBankLoanWage: i18n.t('accounting.transaction_types.2006'),
    withdrawForCompanyLoan: i18n.t('accounting.transaction_types.2007'),
    withdrawForBuyingProperties: i18n.t('accounting.transaction_types.2008'),
    withdrawForBuyingServices: i18n.t('accounting.transaction_types.2009'),
    withdrawForResolvingConflictsFromBank: i18n.t('accounting.transaction_types.2010'),
    withdrawForGivingLend: i18n.t('accounting.transaction_types.2011'),
    withdrawForReturnOfLend: i18n.t('accounting.transaction_types.2012'),
    withdrawForPayingEmployeesSalariesAndBenefits: i18n.t('accounting.transaction_types.2013'),
    withdrawOfUnverifiedOrSuspiciousTransaction: i18n.t('accounting.transaction_types.2998'),
    withdrawOfUnknownOrUnclassifiedTransaction: i18n.t('accounting.transaction_types.2999'),
    createdByAdmin: i18n.t('accounting.transaction_types.3000'),
}

// get all charge transaction types
export function getChargeTransactionTypes() {
    return [
        TRANSACTION_TYPES.chargeThroughTransferFromCompanyOtherBankAccount, // 1000
        TRANSACTION_TYPES.chargeThroughBankReceipt, // 1001
        TRANSACTION_TYPES.chargeThroughSamanDepositWithId, // 1002
        TRANSACTION_TYPES.chargeThroughSaderatDepositWithId, // 1003
        TRANSACTION_TYPES.chargeThroughShaparakSettlement, // 1004
        TRANSACTION_TYPES.chargeThroughPspDirectSettlement, // 1005
        TRANSACTION_TYPES.chargeThroughAyandeDirectDebit, // 1006
        TRANSACTION_TYPES.chargeThroughSaderatDirectDebit, // 1007
        TRANSACTION_TYPES.chargeThroughWalletReversalSettlement, // 1008
        TRANSACTION_TYPES.chargeThroughBankLoan, // 1009
        TRANSACTION_TYPES.chargeThroughCompanyLoanWage, // 1010
        TRANSACTION_TYPES.chargeThroughSellingProperties, // 1011
        TRANSACTION_TYPES.chargeThroughSellingServices, // 1012
        TRANSACTION_TYPES.chargeThroughResolvingConflictsFromBank, // 1013
        TRANSACTION_TYPES.chargeThroughReturnOfLend, // 1014
        TRANSACTION_TYPES.chargeThroughTakingLend, // 1015
        TRANSACTION_TYPES.chargeThroughBankAccountProfit, // 1016
        TRANSACTION_TYPES.chargeThroughIvrSettlement, // 1017
        TRANSACTION_TYPES.chargeThroughSamanDirectDebit, // 1018
        TRANSACTION_TYPES.chargeOfUnverifiedOrSuspiciousTransaction, //1998
        TRANSACTION_TYPES.chargeOfUnknownOrUnclassifiedTransaction //1999
    ];
}

// get all withdrawal transaction types
export function getWithdrawalTransactionTypes() {
    return [
        TRANSACTION_TYPES.withdrawForWalletSettlement, //2000
        TRANSACTION_TYPES.withdrawForTransferToCompanyOtherBankAccount, //2001
        TRANSACTION_TYPES.withdrawForBankWageOfWalletSettlement, //2002
        TRANSACTION_TYPES.withdrawForBankWageOfTransferToCompanyOtherBankAccount, //2003
        TRANSACTION_TYPES.withdrawForPayingDailyCompanyWage, //2004
        TRANSACTION_TYPES.withdrawForBankServices, //2005
        TRANSACTION_TYPES.withdrawForBankLoanWage, //2006
        TRANSACTION_TYPES.withdrawForCompanyLoan, //2007
        TRANSACTION_TYPES.withdrawForBuyingProperties, //2008
        TRANSACTION_TYPES.withdrawForBuyingServices, //2009
        TRANSACTION_TYPES.withdrawForResolvingConflictsFromBank, //2010
        TRANSACTION_TYPES.withdrawForGivingLend, //2011
        TRANSACTION_TYPES.withdrawForReturnOfLend, //2012
        TRANSACTION_TYPES.withdrawForPayingEmployeesSalariesAndBenefits, //2013
        TRANSACTION_TYPES.withdrawOfUnverifiedOrSuspiciousTransaction, //2998
        TRANSACTION_TYPES.withdrawOfUnknownOrUnclassifiedTransaction //2999
    ];
}